<template>
  <o-alert v-if="course && courseRun" :title="$t('components.reservation.create.courseRun.title')" show variant="info" class="m-6">
    <p class="text-sm">
      {{ course.name }} - {{  courseRun.information }}
    </p>
  </o-alert>
</template>

<script setup lang="ts">
import {
  OAlert
} from '@/components/elements'

interface Props {
  course?: object | null
  courseRun?: object | null
}

withDefaults(defineProps<Props>(), {
  course: null,
  courseRun: null,
})
</script>
